module.exports = __webpack_public_path__ + "static/media/main_logo.e02fb0a5.png";